import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";

import { iniChangeItemsChecked } from "../../../../redux/actions/pptosGastos";
import { Lock } from "lucide-react";
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

export const Item = ({
  it,
  separacion_miles,
  separacion_decimales,
  simbolo,
  items,
  handleOpenListCompras,
}) => {
  const presupuestado = parseFloat(it?.total_a_pagar || 0);
  const ejecutado = parseFloat(it?.total_gasto_final || 0);
  const pagado = parseFloat(it?.total_pagado || 0);

  const avanceGastado = (ejecutado / presupuestado) * 100;
  const avancePagado = (pagado / presupuestado) * 100;

  const dispatch = useDispatch();

  const handleChangeChecked = (e) => {
    dispatch(iniChangeItemsChecked(items, e.target.checked, it));
  };

  return (
    <tr key={it.nombre} className="transition-colors">
      <td className="px-5 py-3">
        <div className="flex justify-start items-center">
          {it.cerrado_compras && (
            <Tooltip title="Ítem cerrado para compras">
              <Lock size={14} className="text-[--primary-color]" />
            </Tooltip>
          )}
          <p className="uppercase text-xs ms-2">{it.nombre}</p>
        </div>
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-center">
        {it.cant} × {it.dias}
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right">
        <NumberFormat
          value={it.total_a_pagar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right text-orange-600">
        <Link
          to=""
          onClick={() => handleOpenListCompras("item", it)}
          className="text-orange-600 hover:text-orange-600 hover:underline"
        >
          <NumberFormat
            value={it.total_gasto_final}
            displayType={"text"}
            thousandSeparator={separacion_miles}
            decimalSeparator={separacion_decimales}
            prefix={`${simbolo} `}
            fixedDecimalScale
            decimalScale={2}
          />
        </Link>
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-right text-blue-600">
        <NumberFormat
          value={it.total_por_gastar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right text-green-600">
        <NumberFormat
          value={it.total_pagado}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right text-red-600">
        <NumberFormat
          value={it.total_por_pagar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="px-5 py-3">
        <div className="flex items-center gap-3">
          <div className="relative h-2 w-24 overflow-hidden rounded-full bg-gray-300">
            <div
              className="absolute inset-y-0 left-0 rounded-full bg-orange-400"
              style={{ width: `${avanceGastado}%` }}
            />
            <div
              className="absolute inset-y-0 left-0 rounded-full bg-green-600"
              style={{ width: `${avancePagado}%` }}
            />
          </div>
          <span>
            <NumberFormat
              className={`${avanceGastado > 100 ? "text-red-600" : ""}`}
              value={avanceGastado}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
              suffix="%"
            />
          </span>
        </div>
      </td>
      <td className="border">
        <div className="text-center">
          {!it.cerrado_compras ? (
            <input
              type="checkbox"
              className="w-4 h-4 cursor-pointer"
              onChange={handleChangeChecked}
            />
          ) : (
            <span className="text-[--primary-color] font-semibold">
              Cerrado
            </span>
          )}
        </div>
      </td>
    </tr>
  );
};
